<template>
    <transition
        @enter="enterTransition"
        @leave="leaveTransition"
        :css="false"
    >
        <div class="alert" :class="classes" role="alert">
            <h4 :class="['alert-heading', {'mb-0': !contentVisible}]" v-if="headingVisible">
                <slot name="heading">{{heading}}</slot>
            </h4>

            <slot v-if="contentVisible">
                <template v-if="escape">{{content}}</template>
                <div v-else v-html="content" />
            </slot>

            <oc-button-input v-if="closeButton" class="close" @click="$emit('close')">
                <span>&times;</span>
            </oc-button-input>
        </div>
    </transition>
</template>
<script>
import Velocity from 'velocity'

export default {
    name: 'oc-alert',
    props: {
        type: {
            type: String,
            default: 'error',
            validator: function (value) {
                return ['warning', 'error', 'success', 'info'].indexOf(value) !== -1
            }
        },
        heading: {
            type: String
        },
        content: {
            type: String
        },
        closeButton: {
            type: Boolean,
            default: true
        },
        animation: {
            type: [Boolean, String],
            default: 'ease-in-out',
            validator: function (value) {
                return [false, 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out'].indexOf(value) !== -1
            }
        },
        escape: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        enterTransition (el, done) {
            if(false === this.animation) {
                return done()
            }
            Velocity(el, "fadeIn", { duration: 300, easing: this.animation, complete: done})
        },
        leaveTransition (el, done) {
            if(false === this.animation) {
                return done()
            }
            Velocity(el, "fadeOut", { duration: 300, easing: this.animation, complete: done})
        }
    },
    computed: {
        $_type() {
            if( 'error' === this.type ) {
                return 'danger'
            }

            return this.type
        },
        headingVisible() {
            return this.heading || this.$slots.heading
        },
        contentVisible() {
            return this.content || this.$slots.default
        },
        classes() {
            return [
                'alert-' + this.$_type,
                {
                    'alert-dismissible': this.closeButton,
                    'show': this.closeButton
                }
            ]
        }
    }
}
</script>
